import { render, staticRenderFns } from "./EditBFRetailerPlanDialog.vue?vue&type=template&id=a9382cba"
import script from "./EditBFRetailerPlanDialog.vue?vue&type=script&lang=js"
export * from "./EditBFRetailerPlanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports